import axios from "axios";
import { BASE_URL } from "../Utils/base_url";
const InscriptionClientRequest = async (data) => {
    return await axios.post(`${BASE_URL}/inscriptionClient`, data);
}

const LoginClientRequest = async (data) => {
    return await axios.post(`${BASE_URL}/loginClient`, data);
}

export {InscriptionClientRequest,LoginClientRequest};